export const onRemove = (index) => ({
  type: 'REMOVE',
  index
})

export const onSetChosen = (chosen) => ({
  type: 'CHOOSE',
  chosen
})